export const agentRequests = {
  page: {
    filters: {
      accommodation: "مكان الإقامة",
      type: "النوع",
    },
    subtitle: "ما طلبه ضيوفك عبر الوكيل.",
    clearFilters: "مسح عوامل التصفية",
    loadMore: "عرض المزيد",
    empty: "لا توجد طلبات بعد.",
    emptyFiltered: "لا توجد طلبات بهذه العوامل.",
    columns: {
      type: "النوع",
      guest: "الضيف",
      asks: "الطلب",
      channel: "القناة",
      status: "الحالة",
      when: "متى",
      amount: "المبلغ",
    },
  },
  // La columna Importe: en qué quedó el cobro de cada solicitud.
  amount: {
    paid: "مدفوع",
    awaiting: "بانتظار الدفع",
    property: "يُدفع في مكان الإقامة",
    void: "لم يُحصّل",
    quote: "معروض",
  },
  common: {
    title: "طلبات الاستقبال بالذكاء الاصطناعي",
  },
  widget: {
    iaBadge: "ذكاء اصطناعي",
    subtitle: "ما طلبه نزلاؤك عبر الوكيل.",
    todayOn: "يتم عرض طلبات اليوم فقط",
    todayOff: "عرض طلبات اليوم فقط",
    today: "اليوم",
    entersToday: "يصل اليوم",
    entersTodayTitle: "هذا الحجز يصل اليوم",
    test: "تجريبي",
    approve: "قبول",
    otherTime: "وقت آخر",
    prioritize: "إعطاء الأولوية",
    reject: "رفض",
    dismiss: "إزالة من اللوحة",
    loading: "جارٍ تحميل الطلبات…",
    empty: "لا توجد طلبات بعد.",
    emptySub: "عندما يطلب أحد النزلاء مغادرة متأخرة أو وصولاً مبكراً أو ليالي إضافية، سيظهر هنا.",
    viewAll: "عرض جميع الطلبات",
    entryTime: "وقت تسجيل الوصول",
    cancel: "إلغاء",
    rejectIrreversible: "لا يمكن التراجع عن هذا الإجراء.",
    modal: {
      approveTitle: "الموافقة على الطلب؟",
      approveTimeTitle: "الموافقة في وقت آخر؟",
      tentativeTitle: "إعطاء الأولوية لهذا الوصول؟",
      rejectTitle: "رفض الطلب؟",
      defaultTitle: "تأكيد؟",
      approveText: "أنت على وشك الموافقة على الوصول المبكر لـ",
      approveTimeText: "ستؤكد الوصول في الوقت الذي تحدده لـ",
      tentativeText: "سنخبره بأنكم ستبذلون كل ما في وسعكم ليكون جاهزًا في ذلك الوقت، مع أن ذلك يعتمد على مغادرة النزيل السابق والتنظيف. سيُرسل إلى",
      rejectText: "أنت على وشك رفض الوصول المبكر لـ",
      defaultText: "تأكيد لـ",
      approveCta: "نعم، الموافقة",
      approveTimeCta: "تأكيد الوقت",
      tentativeCta: "نعم، إبلاغ",
      rejectCta: "نعم، الرفض",
      defaultCta: "تأكيد",
    },
  },
  drawer: {
    close: "إغلاق",
    allAccommodations: "جميع أماكن الإقامة",
    allTypes: "جميع الأنواع",
    today: "اليوم",
    yesterday: "أمس",
    from: "من",
    to: "إلى",
    clear: "مسح",
    writeWhatsapp: "المراسلة عبر واتساب",
    noMessages: "لا توجد رسائل محفوظة لهذه المحادثة.",
    pause: "إيقاف مؤقت",
    play: "تشغيل",
    downloadMp3: "تنزيل MP3",
    viewReservation: "عرض الحجز",
    loading: "جارٍ التحميل…",
    emptyFiltered: "لا توجد طلبات مطابقة لهذه الفلاتر.",
    end: "لا مزيد من الطلبات.",
    features: {
      early: "تسجيل وصول مبكر",
      late: "مغادرة متأخرة",
      extend: "تمديد الإقامة",
      invoice: "فاتورة",
      handoff: "إجراء مطلوب",
      callMessage: "رسائل المكالمات",
    },
    channels: {
      call: "مكالمة",
    },
  },
  box: {
    rooms: "{count} غرفة | {count} غرف",
    nights: "{count} ليلة | {count} ليالٍ",
    guests: "{count} نزيل | {count} نزلاء",
    earlyRequestedTitle: "تم طلب تسجيل وصول مبكر",
    arrivalRequestedTitle: "تم طلب وقت الوصول",
    early: "مبكر",
    arrives: "الوصول",
  },
};
